<template>
  <el-card class="box-card">
    <PageTitle :title="$t('atualizacao-objetos-sro')" :pagination="false" />
    <br />
    <el-card shadow="hover">
      <el-form :model="ruleForm" :inline="true" ref="ruleForm">
        <el-row :gutter="5">
          <el-col :span="20">
            <el-form-item :label="$t('periodo')" prop="name">
              <el-date-picker
                v-model="ruleForm.range"
                type="daterange"
                align="right"
                unlink-panels
                clearable
                :picker-options="pickerOptions"
                :default-value="ruleForm.range"
                range-separator="à"
                format="dd/MM/yyyy"
                start-placeholder="Inicio"
                end-placeholder="Fim"
              ></el-date-picker>
            </el-form-item>
            <el-form-item
              :label="userType === '1' || userType === '3' ? $t('cliente') : $t('filial')"
              prop="customer"
              v-if="userType !== '5'"
            >
              <CustomerList
                v-model="ruleForm.customer"
                v-bind:multiple="true"
                v-bind:customerType="userType === '2' ? 3 : 0"
              />
            </el-form-item>
            <el-form-item :label="$t('servico')" prop="services">
              <ServicesList v-model="ruleForm.services" :multiple="true" />
            </el-form-item>
            <el-button class="right" type="warning" @click="$router.push({ name: 'request.info' })"
              >Fale Conosco</el-button
            >&nbsp;
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="20">
            <el-form-item>
              <el-radio-group v-model="ruleForm.type">
                <el-radio label="total">Todas</el-radio>
                <el-radio label="warning">Somente importantes</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-button type="info" size="mini" @click="filter">Filtrar</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-container>
      <PostSroMenu @redirect="redirect" />
      <PostSroMainHome
        ref="home"
        v-if="page === 'home'"
        :startedAt="ruleForm.range[0]"
        :finishedAt="ruleForm.range[1]"
        :customer="ruleForm.customer"
        :services="ruleForm.services"
      />
      <PostSroMainTable
        ref="sroTable"
        v-if="page === 'table'"
        :startedAt="ruleForm.range[0]"
        :finishedAt="ruleForm.range[1]"
        :customer="ruleForm.customer"
        :services="ruleForm.services"
      />
    </el-container>
  </el-card>
</template>
<script>
import { PrepostService } from "@/services/customers/prepost.services";
import { UserService } from "@/services/users/user.services";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import ServicesList from "@/xpost/views/register/services/ServicesList";
import PageTitle from "./components/PageTitle";
import PostSroMenu from "./components/sro/PostSroMenu";
import PostSroMainTable from "./components/sro/PostSroMainTable.vue";
import PostSroMainHome from "./components/sro/PostSroMainHome.vue";

export default {
  name: "PostObjectSro",
  components: {
    PageTitle,
    CustomerList,
    ServicesList,
    PostSroMenu,
    PostSroMainTable,
    PostSroMainHome,
  },
  data() {
    return {
      page: "home",
      userType: "1",
      pickerOptions: {
        shortcuts: [
          {
            text: "Últimas 24h",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Última Semana",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Último Mês",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Últimos 3 meses",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      ruleForm: {
        range: [],
        customer: [],
        services: [],
        type: "total",
        records: 50,
        page: 1,
      },
    };
  },
  methods: {
    redirect(page) {
      this.page = page;
    },
    filter() {
      this.fetch();
    },
    fetch() {
      const vm = this;
      if (vm.$refs.home) vm.$refs.home.fetch();
      else vm.$refs.table.fetch();
    },
  },
  mounted() {
    const vm = this;
    setTimeout(() => {
      if (vm.$route.params.startedAt) vm.ruleForm.range.push(new Date(`${vm.$route.params.startedAt} 12:00:00`));
      else vm.ruleForm.range.push(new Date().setDate(new Date().getDate() - 3));
      if (vm.$route.params.finishedAt) vm.ruleForm.range.push(new Date(`${vm.$route.params.finishedAt} 12:00:00`));
      else vm.ruleForm.range.push(new Date());
      if (vm.$route.params.customer) vm.ruleForm.customer = vm.$route.params.customer;
      if (vm.$route.params.services) vm.ruleForm.services = vm.$route.params.services;
      if (vm.$route.params.type) vm.ruleForm.type = vm.$route.params.type;
      UserService.me()
        .then((response) => {
          vm.userType = response.type;
          vm.fetch();
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        });
    }, 500);
  },
};
</script>

<style>
.el-drawer__body {
  overflow-y: auto !important;
}
.el-picker-panel [slot="sidebar"] + .el-picker-panel__body,
.el-picker-panel__sidebar + .el-picker-panel__body {
  margin-left: 135px;
}
.el-picker-panel [slot="sidebar"],
.el-picker-panel__sidebar {
  width: 135px;
}
</style>
